import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Homepage from './components/Homepage';
import SellerDirectory from './components/SellerDirectory';
import SellerDetailPage from './components/SellerDetailPage';
import PremiumSubscription from './components/PremiumSubscription';
import EnhancedProfile from './components/EnhancedProfile';
import LoginPage from './components/LoginPage';
import RegisterPage from './components/RegisterPage';
import AnalyticsPage from './pages/AnalyticsPage';
import Footer from './components/Footer';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <Navigation />
        
        <main>
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/directory" element={<SellerDirectory />} />
            <Route path="/seller/:id" element={<SellerDetailPage />} />
            <Route path="/premium" element={<PremiumSubscription />} />
            <Route path="/profile" element={<EnhancedProfile />} />
            <Route path="/analytics" element={<AnalyticsPage />} />
            <Route path="/about" element={<div className="container mx-auto px-4 py-8"><h1 className="text-3xl font-bold">About Page Coming Soon</h1></div>} />
            <Route path="/contact" element={<div className="container mx-auto px-4 py-8"><h1 className="text-3xl font-bold">Contact Page Coming Soon</h1></div>} />
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
}

export default App;